/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { ExportPricesDto } from '@gh/builder-shared-data';
import {
  DownloadDialogConfig,
  downloadDialogRoute,
  textMessageDialogRoute,
} from '@gh/common-internal-shared';
import { AutocompleteItem } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import {
  AutocompleteLoadMoreEvent,
  DialogService,
  NotificationService,
  TextMessageDialogConfig,
  WaitingService,
} from '@gh/core-ui';
import { assign, isEmpty, isNil } from 'lodash';
import { ExportPriceBusinessService } from '../../resources/export-prices-business.service';
import { ExportPricesLink } from '../../resources/export-prices.model';
import { ExportPricesGridDefinition } from './export-prices-grid-definition.service';
import { TranslationService } from '@gh/core-mls';
import { createLink } from '@gh/core-util';

@Component({
  standalone: false,
  selector: 'gh-export-prices-tab',
  templateUrl: 'export-prices-tab.component.html',
  styleUrls: ['export-prices-tab.component.scss'],
  viewProviders: [ExportPricesGridDefinition],
})
export class ExportPricesTabComponent {

  dataSource: SlicedDataSource<ExportPricesDto>;
  selectFromItem: AutocompleteItem;
  selectToItem: AutocompleteItem;
  readyForExport: boolean = false;

  constructor(private businessService: ExportPriceBusinessService,
              public dialogService: DialogService,
              public gridDefinition: ExportPricesGridDefinition,
              private notificationService: NotificationService,
              private waitingService: WaitingService,
              private translationService: TranslationService) {
  }

  loadFromListOfItems($event: AutocompleteLoadMoreEvent): void {
    $event.load(this.businessService.loadListOfItems($event.query));
  }

  loadToListOfItems($event: AutocompleteLoadMoreEvent): void {
    $event.load(this.businessService.loadListOfItems($event.query, this.selectFromItem.name));
  }

  onPreview(): void {
    this.readyForExport = true;
    this.dataSource = this.businessService.loadPreview(this.selectFromItem.name, this.selectToItem.name);
  }

  onGenerateFile(type: string): void {
    this.businessService.getFileByFilter(this.selectFromItem.name, this.selectToItem.name, type).pipe(
      this.waitingService.operator<ExportPricesLink>())
      .subscribe((response) => {
          this.cleanPreview();
          if (type === 'excel') {
            this.dialogService.openWithInput(downloadDialogRoute, <DownloadDialogConfig>{
              messageId: 'msg_export_file_generated',
              link: response.url,
              fileName: response.fileName,
            });
          } else {
            this.dialogService.openWithInput(textMessageDialogRoute, <TextMessageDialogConfig<string>>{
              title: this.translationService.get('lbl_link_to_google_sheet'),
              html: `${this.translationService.get('lbl_link_to_generated_doc')}:\n${createLink(response.url)}`,
              buttons: [{ value: 'ok', title: this.translationService.get('lbl_ok'), type: 'primary' }],
            }).afterClosed();
          }
        },
                 this.notificationService.processAll,
      );
  }

  onChangeFrom(): void {
    if (isEmpty(this.selectFromItem)) {
      this.cleanPreview();
    } else {
// @ts-expect-error Legacy typing suppression
      delete this.selectToItem;
      this.readyForExport = false;
    }
  }

  onChangeTo(): void {
    this.readyForExport = false;
  }

  cleanPreview(): void {
    this.readyForExport = false;
    assign(this, { selectFromItem: void 0, selectToItem: void 0 });
  }

  get disableToInput(): boolean {
    return isNil(this.selectFromItem);
  }

  get disablePreviewButton(): boolean {
    return isNil(this.selectFromItem) || isNil(this.selectToItem);
  }
}
